export default __webpack_public_path__ + "static/Plots0003-563ae14462e519e5166040f74ca7561f.jpg";